exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".AmplitudePerFrequencyGraph_custom_legend{display:flex}.AmplitudePerFrequencyGraph_custom_legend>div{margin-right:10px}.AmplitudePerFrequencyGraph_clickable_legend_items_container{margin-left:-30px}.AmplitudePerFrequencyGraph_noisy_channel{position:absolute;width:100%;-webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px);display:flex;justify-content:center;height:200px;align-items:center;top:0;flex-direction:column;font-weight:900}\n", ""]);

// Exports
exports.locals = {
	"custom_legend": "AmplitudePerFrequencyGraph_custom_legend",
	"clickable_legend_items_container": "AmplitudePerFrequencyGraph_clickable_legend_items_container",
	"noisy_channel": "AmplitudePerFrequencyGraph_noisy_channel"
};